import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './index.scss'
import { NavigationProvider } from './contexts/navigationContext'
import { Provider } from 'react-redux'
import store from './store'
import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import GlobalFeatureFlagProvider from './providers/globalFeatureFlag.provider'
import authLogger from './utils/authLogger'

// Log app initialization
authLogger.info('App', 'Application starting', {
    url: window.location.href,
    userAgent: navigator.userAgent,
    timestamp: new Date().toISOString(),
})

ReactDOM.render(
    <Provider store={store}>
        <GlobalFeatureFlagProvider>
            <NavigationProvider>
                <App />
            </NavigationProvider>
        </GlobalFeatureFlagProvider>
    </Provider>,
    document.getElementById('root')
)
